export const GET_ATTRIBUTES = 'pam/GET_ATTRIBUTES'
export const GET_ATTRIBUTES_SUCCESS = 'pam/GET_ATTRIBUTES_SUCCESS'
export const GET_ATTRIBUTES_FAIL = 'pam/GET_ATTRIBUTES_FAIL'

export const ADD_ATTRIBUTE = 'pam/ADD_ATTRIBUTE'
export const ADD_ATTRIBUTE_SUCCESS = 'pam/ADD_ATTRIBUTE_SUCCESS'
export const ADD_ATTRIBUTE_FAIL = 'pam/ADD_ATTRIBUTE_FAIL'

export const UPDATE_ATTRIBUTE = 'pam/UPDATE_ATTRIBUTE'
export const UPDATE_ATTRIBUTE_SUCCESS = 'pam/UPDATE_ATTRIBUTE_SUCCESS'
export const UPDATE_ATTRIBUTE_FAIL = 'pam/UPDATE_ATTRIBUTE_FAIL'

export const DELETE_ATTRIBUTE = 'pam/DELETE_ATTRIBUTE'
export const DELETE_ATTRIBUTE_SUCCESS = 'pam/DELETE_ATTRIBUTE_SUCCESS'
export const DELETE_ATTRIBUTE_FAIL = 'pam/DELETE_ATTRIBUTE_FAIL'

export const pamGetAttributes = payload => ({
  type: GET_ATTRIBUTES,
  payload
})

export const pamGetAttributesSuccess = payload => ({
  type: GET_ATTRIBUTES_SUCCESS,
  payload
})

export const pamGetAttributesFail = payload => ({
  type: GET_ATTRIBUTES_FAIL,
  payload
})

export const pamAddAttribute = payload => ({
  type: ADD_ATTRIBUTE,
  payload
})

export const pamAddAttributeSuccess = payload => ({
  type: ADD_ATTRIBUTE_SUCCESS,
  payload
})

export const pamAddAttributeFail = payload => ({
  type: ADD_ATTRIBUTE_FAIL,
  payload
})

export const pamUpdateAttribute = payload => ({
  type: UPDATE_ATTRIBUTE,
  payload
})

export const pamUpdateAttributeSuccess = payload => ({
  type: UPDATE_ATTRIBUTE_SUCCESS,
  payload
})

export const pamUpdateAttributeFail = payload => ({
  type: UPDATE_ATTRIBUTE_FAIL,
  payload
})

export const pamDeleteAttribute = payload => ({
  type: DELETE_ATTRIBUTE,
  payload
})

export const pamDeleteAttributeSuccess = payload => ({
  type: DELETE_ATTRIBUTE_SUCCESS,
  payload
})

export const pamDeleteAttributeFail = payload => ({
  type: DELETE_ATTRIBUTE_FAIL,
  payload
})
